module.exports = __webpack_public_path__ + "cz.svg?2292229b574cfc32819745af03fd3599";